import { render } from "./LoginForm.vue?vue&type=template&id=9b1f8870&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=9b1f8870&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9b1f8870"

export default script